import { Component, Injector, Input } from '@angular/core';
import { TableDummiesWidgetBaseComponent } from '../table-dummies-widget-base/table-dummies-widget-base';

/**
 * TableDummies3Full Widget
 */
@Component({
  selector: 'table-dummies3-full-widget',
  templateUrl: './table-dummies3-full-widget.component.html',
  styleUrls: ['../../common/css/general.scss', '../table-dummies-widget-base/table-dummies-widget-base.scss']
})
export class TableDummies3FullWidgetComponent extends TableDummiesWidgetBaseComponent {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'tableDummies3Full');
  }
}
